import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { Spinner } from "react-bootstrap";
import { Alert, ListGroup, Accordion } from "react-bootstrap";
import Icon from "../Icon/Icon";
import { Modal, Button ,Row, Col} from "react-bootstrap";
import {DatePicker,TimePicker} from "../../components";
import { Form } from "react-bootstrap";
import toTimeOnly from "../../utilities/toTimeOnly";
import toDateOnly from "../../utilities/toDateOnly";
import { useApiClient } from "../../ApiService/useApiClient";



function detailSelect (row,currentTaskId) {
 alert(row.id)
 alert(currentTaskId)
}


const JobsheetDetailMedication = ({customerid,taskId,taskDate}) => {

  const api = useApiClient();

  const selectMedItem = [{
    TakenOrNot : '',
    UsageStatus : '',
  }];

  const [selectedMedItem,setSelectedMedItem] = useState(selectMedItem);

  const formDefault = {
    opened : false
  };
  const [formModal, setFormModal] = useState(formDefault);

  const [currentCusromerId, setCurrentCusromerId] = useState(customerid);
  const [currentTaskId, setcurrentTaskId] = useState(taskId);
  const [currentTaskDate, setcurrentTaskDate] = useState(taskDate);
  const [data, setData] = useState(null);
  const [error, setError] = useState(null); 
  const [previewModal, setpreviewModal] = useState(false); 
  const [medUpdated, setMedUpdated] = useState(null);
  const [CurrentUsageData, setCurrentUsageData] = useState(null);



  function MedHeaderItemClicked(meditem2, medScheduleTime){


    const sURL = "HMCareTask/getMedUsage/";
    
    const frmFormData = new FormData();
    frmFormData.append("MedicaionId", meditem2.id)
    frmFormData.append("UsageDate", currentTaskDate)
    frmFormData.append("UsageSchedule", medScheduleTime)

console.log(frmFormData)

  api.post(sURL,frmFormData)
  .then((Response)=>{
      setCurrentUsageData(Response.data);
      //console.log(Response.data)
  }).catch(error => {
      setError(error);     
      //console.log({error})
  });

    //console.log(meditem2)
    //console.log(medScheduleTime)

    const currMedItem = {...selectMedItem,
     
      emarMedicationName : meditem2.emarMedicationName,
      emarMedicationDesc:meditem2.emarMedicationDesc,
      emarMedicationDosage:meditem2.emarMedicationDosage,
      emarMedicationUsageInstructions: meditem2.emarMedicationUsageInstructions,
      UsageSchedule:medScheduleTime,
      MedicaionId:meditem2.id,
      TakenOrNot : '',
      UsageStatus : '',
      UsageNotes:'',
      UsageDateTime:'', 
      UsageDateTime : currentTaskDate, //new Date(),         
    }

    setSelectedMedItem(currMedItem);
    setFormModal(currMedItem)

    //console.log(selectedMedItem)

    setpreviewModal(true)


  }
  
  const handleChange = (event) => {
    setFormModal({
      ...formModal,
      [event.target.name]: event.target.value
    });
    
    console.log(event.target.name +'=='+ event.target.value)
    console.log(event.target)
  }

  function handleFormSubmit(event){
    event.preventDefault();

    if(formModal.TakenOrNot!="" && formModal.UsageStatus !="" ){

    let UsageDate = formModal.current.querySelector('#UsageDate').value; 
    let UsageTime = formModal.current.querySelector('#UsageTime').value; 

    const frmFormData = new FormData();
    frmFormData.append("TaskId", currentTaskId)
    frmFormData.append("MedicaionId", selectedMedItem.MedicaionId)
    frmFormData.append("UsageDate", UsageDate + (UsageTime ? 'T' + UsageTime + 'Z' : ''))
    frmFormData.append("UsageSchedule", selectedMedItem.UsageSchedule)
    frmFormData.append("TakenOrNot", formModal.TakenOrNot)
    frmFormData.append("UsageStatus", formModal.UsageStatus)
    frmFormData.append("UsageNotes", formModal.UsageNotes)
    frmFormData.append("UsageDateTime", UsageDate + (UsageTime ? 'T' + UsageTime + 'Z' : ''))
    
    const sURL = "HMCareTask/carerUpdateMeds/";
    
  api.post(sURL,frmFormData)
  .then((Response)=>{
      //setClients(Response.data);
      console.log(Response.data)
      setMedUpdated(true);
      setCurrentUsageData(Response.data);
  }).catch(error => {
      setError(error);     
      //console.log({error})
  });

   // console.log(UsageDate +'===='+ UsageTime + formModal.TakenOrNot )
    //console.log(frmFormData)
    closePreviewModal();
}
  }


  function closePreviewModal(){
    setpreviewModal(false)
  }
  

  function getTakenOrNotDisplay(code){
    if(code=="taken") return <Button variant="success"  className="rounded-pill" disabled={true} value="Taken">Taken</Button>            
    if(code=="not taken") return <Button variant="warning"  className="rounded-pill" disabled={true} value="Taken">Not Taken</Button>            
  }
  function getUsageNameToDisplay(code){
    if(code=="P") return "Prompt"    
    if(code=="A") return "Administrated"    
    if(code=="R") return "Refused"    
    if(code=="NV") return "Nausea/Vomiting"    
    if(code=="H") return "Hospital"    
    if(code=="D") return "Discountinued"    
    if(code=="NR") return "Not Required"    
    if(code=="OS") return "Out of Supply"        
  }

  useEffect(()=>{

    const baseURL = "HMCareTask/taskmedicationheaders/"+currentCusromerId;

    api.get(baseURL)        
            .then((Response)=>{
                setData(Response.data);
            }).catch(error => {
                setError(error);     
                //console.log({error})
            });  

  },[medUpdated]);
  
  {!data && <Spinner animation="border" variant="primary" />}

  {error && 
    <Alert variant="danger">{error}</Alert>}

  
  if(data) return (
    <>

      {data.map((dataitem)=>
          <>


    <Accordion defaultActiveKey="0" key={dataitem.id}>
      <Accordion.Item eventKey={dataitem.id} flush>
        <Accordion.Header>

          {/* <Alert variant="info"> */}
          <h5>
            <Icon variant="primary" size="md" name="sun"></Icon>
            {dataitem.timeOfMedication}
          </h5>
          {dataitem.medicationHeaders && <b> ( {dataitem.medicationHeaders.length} Meds )</b>}
          {/* </Alert> */}

        </Accordion.Header>
        <Accordion.Body>     
    
          <ListGroup>            
          {dataitem.medicationHeaders && dataitem.medicationHeaders.map((meditem) =>
            <>
            <ListGroup.Item action className="py-3" onClick={() => MedHeaderItemClicked(meditem, dataitem.timeOfMedication)} key={meditem.id}>
                <div className="d-flex w-100 justify-content-between">
                    <h5 className="mb-1">{meditem.emarMedicationName}</h5>
                    <small>Update Medication</small>
                </div>
                <p className="mb-1">{meditem.emarMedicationDosage}</p>
                <small>{meditem.emarMedicationDesc}</small>
                <small>{meditem.emarMedicationUsageInstructions}</small>
            </ListGroup.Item>            
            </>      
          )}          
          </ListGroup>

        </Accordion.Body>
      </Accordion.Item>  
    </Accordion>     
{/* <Modal show={previewModal} onHide={closePreviewModal}> */}

{CurrentUsageData && 

<Modal show={previewModal}>    
            <Modal.Header>
              <Modal.Title className="event-title" as="h4">{selectedMedItem.UsageSchedule} Time Dose</Modal.Title>
              <Modal.Title className="event-title" as="h6">On {toDateOnly(CurrentUsageData.usageDateTime)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Row className="g-4">

                    <Col xs="12">
                        <h6 className="overline-title">{selectedMedItem.emarMedicationName}</h6>
                        <p className="event-end small">{selectedMedItem.emarMedicationDosage}</p>                                                                        
                    </Col>                   
                    
                    <Col xs="12">
                        <h6 className="overline-title">{getTakenOrNotDisplay(CurrentUsageData.takenOrNot)} (Updated on {toDateOnly(CurrentUsageData.usageDateTime)} at {toTimeOnly(CurrentUsageData.usageDateTime)})</h6>
                        <p className="event-end small">{getUsageNameToDisplay(CurrentUsageData.usageStatus)}</p>                                                                        
                    </Col>
                    <Col xs="12">
                        <h6 className="overline-title">Notes</h6>
                        <p className="event-end small">{CurrentUsageData.usageNotes}</p>                                                                        
                    </Col>                    
                    <Col xs="12">
                        <h6 className="overline-title">Carer</h6>
                        <p className="event-end small">{CurrentUsageData.updatedUserId}</p>                                                                        
                    </Col>                    
                    <Col xs="12">
                    
                    </Col>
                </Row>
              </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={closePreviewModal} >Cancel</Button>                
            </Modal.Footer>            
        </Modal>

}


{!CurrentUsageData && 
   
 
    <Modal show={previewModal}>
    <Form ref={formModal} onSubmit={handleFormSubmit}>
            <Modal.Header>
              <Modal.Title className="event-title" as="h4">{selectedMedItem.UsageSchedule} Time Dose</Modal.Title>
              <Modal.Title className="event-title" as="h6">For {toDateOnly(selectedMedItem.UsageDateTime)}</Modal.Title>
            </Modal.Header>
            <Modal.Body>
              <div>
                <Row className="g-4">

                    <Col xs="12">
                        <h6 className="overline-title">{selectedMedItem.emarMedicationName}</h6>
                        <p className="event-end small">{selectedMedItem.emarMedicationDosage}</p>                                                
                    </Col>
                    
                    <Col xs="12">
                    {/* <Button active={formModal.TakenOrNot == "taken"} className="rounded-pill" variant="outline-success" id="TakenOrNot" name="TakenOrNot" value="taken" onClick={handleChange} style={{ margin: '5px' }} ><span style={{ marginLeft: '2.5rem', marginRight : '2.5rem' }}>Taken</span></Button>                     
                    <Button active={formModal.TakenOrNot == "not taken"} className="rounded-pill" variant="outline-danger" id="TakenOrNot1" name="TakenOrNot" value="not taken" onClick={handleChange} style={{ margin: '5px' }}><span style={{ marginLeft: '2.0rem', marginRight : '2.0rem' }}>Not Taken</span></Button>                                                                   */}
                    <Button active={formModal.TakenOrNot == "taken"} className="rounded-pill" variant="outline-success" id="TakenOrNot" name="TakenOrNot" value="taken" onClick={handleChange} style={{ margin: '5px' }} >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Taken&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;</Button>                     
                    <Button active={formModal.TakenOrNot == "not taken"} className="rounded-pill" variant="outline-danger" id="TakenOrNot1" name="TakenOrNot" value="not taken" onClick={handleChange} style={{ margin: '5px' }}>Not Taken</Button>                                                                  
                    </Col>

                    {/* <Col xs="6">
                      <Button active={formModal.TakenOrNot == "not taken"} className="rounded-pill" variant="outline-danger" id="TakenOrNot" name="TakenOrNot" value="not taken" onClick={handleChange}><span style={{ marginLeft: '2.0rem', marginRight : '2.0rem' }}>Not Taken</span></Button>                                                                  
                    </Col>
                     */}

                    {formModal.TakenOrNot == "taken" && 
                    <Col xs="12">

                    <h6 className="overline-title">How client Taken the Dose?</h6>      
                    <Button active={formModal.UsageStatus=="P"} variant="outline-info" size="sm" className="rounded-pill" id="UsageStatus" name="UsageStatus" value="P" onClick={handleChange}>Promptly</Button> 
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="A"} variant="outline-info" size="sm" className="rounded-pill" id="UsageStatus2" name="UsageStatus" value="A" onClick={handleChange}>Administrated</Button> 
                    </Col>
                    }
                    {formModal.TakenOrNot == "not taken" && 
                    <Col xs="12">
                    <h6 className="overline-title">Why not taken ? </h6>      
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="R"} variant="outline-danger" size="sm" className="rounded-pill" id="UsageStatus3" name="UsageStatus" value="R" onClick={handleChange}>Refused</Button> 
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="NV"} variant="outline-danger" size="sm" className="rounded-pill" id="UsageStatus4" name="UsageStatus" value="NV" onClick={handleChange}>Nausea/Vomiting</Button> 
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="H"} variant="outline-danger" size="sm" className="rounded-pill" id="UsageStatus5" name="UsageStatus" value="H" onClick={handleChange}>Hospital</Button> 
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="D"} variant="outline-danger" size="sm" className="rounded-pill" id="UsageStatus6" name="UsageStatus" value="D" onClick={handleChange}>Discountinued</Button> 
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="NR"} variant="outline-danger" size="sm" className="rounded-pill" id="UsageStatus7" name="UsageStatus" value="NR" onClick={handleChange}>Not Required</Button> 
                    <Button style={{margin:'5px'}} active={formModal.UsageStatus=="OS"} variant="outline-danger" size="sm" className="rounded-pill" id="UsageStatus8" name="UsageStatus" value="OS" onClick={handleChange}>Out of Supply</Button>                                          
                    </Col>
                    }
                    <Col xs="12">                        
                        <h6 className="overline-title">Date Time</h6>                        
                    </Col>
                    <Col xs="4">                        
                        <DatePicker id="UsageDate" name="UsageDateTime" value={selectedMedItem.UsageDateTime} placeholder="yyyy-mm-dd" onChange={handleChange}/>                        
                    </Col>
                    
                    <Col xs="3">                                                
                        <TimePicker id="UsageTime" name="UsageDateTime" value={toTimeOnly(selectedMedItem.UsageDateTime)} placeholder="hh:mm" onChange={handleChange}/>                    
                    </Col>                    
                    
                    <Col xs="12">
                    <Form.Group>
                                <Form.Label htmlFor="UsageNotes">Notes</Form.Label>
                                <div className="form-control-wrap">
                                    <Form.Control id="UsageNotes" name="UsageNotes" as="textarea" placeholder="Notes" defaultValue={selectedMedItem.UsageNotes} onChange={handleChange} />
                                </div>
                            </Form.Group>
                    </Col>

                </Row>
              </div>
            </Modal.Body>
            <Modal.Footer>
                <Button variant="light" onClick={closePreviewModal} >Cancel</Button>
                <Button variant="primary" type="submit" disabled = {!(selectedMedItem.TakenOrNot =="" && selectedMedItem.UsageStatus =="")} >Update Medication</Button>
            </Modal.Footer>
            </Form>
        </Modal>
      }
                    
          </>
      )}
      
    </>
    
  )
}

export default JobsheetDetailMedication